import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles, TextFieldExtraProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IntegrationFormTypes } from "models/formTypes";
import { SimpleFormProps } from "models/propTypes/integrationsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
import { RefreshButton } from "components/common";
import { useSettingsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SimpleForm: ForwardRefRenderFunction<FormHandles, SimpleFormProps> = (props, ref) => {
  const settingsService = useSettingsService();

  return (
    <GenericForm<IntegrationFormTypes.SimpleIntegration>
      formRef={ref}
      {...props}
      fields={{
        isActive: {
          label: props.isActiveText,
          type: FormEnums.FormFieldType.TOGGLE,
          classes: { formControl: cssExports.inlineLabel },
        },
        logingDetails: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          customField: (
            <>
              <Grid container className={cssExports.formControlLabel}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Integrations.QbisLoginDetails)}
              </Grid>
              <Grid container className={cssExports.formControlDescription}>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Integrations.QbisLoginDetailsDescription
                )}
              </Grid>
            </>
          ),
        },
        userName: {
          label: TranslationKeys.Integrations.UserName,
          type: FormEnums.FormFieldType.TEXT,
          hidden: (values: IntegrationFormTypes.SimpleIntegration) => !values.isActive,
          disabled: true,
        },
        apiKey: {
          label: "",
          type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
          hidden: (values: IntegrationFormTypes.SimpleIntegration) => !values.isActive,
          innerFields: {
            apiKey: {
              label: TranslationKeys.Integrations.ApiKey,
              type: FormEnums.FormFieldType.TEXT,
              widthColumnCount: 11,
              disabled: true,
              extraProps: { showCopyButton: true } as TextFieldExtraProps,
            },
            refresh: {
              label: "",
              type: FormEnums.FormFieldType.CUSTOM,
              customField: (
                <RefreshButton onChange={() => {}} onClick={settingsService.generateCustomAppApiKey}></RefreshButton>
              ),
              onChangeHandler: props.onApiKeyRefresh,
              widthColumnCount: 1,
            },
          },
        },
      }}
    />
  );
};

export default forwardRef(SimpleForm);
